import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Components";
import Loader from "../commonComponent/Loader";
import { countryCode, getOperatorFromSubServiceId, normalizeOperator } from "../config/wapConfig";
import {
  checkSubcription,
  subscriptionActivation,
  authorizationToken,
  login,
  antifraudScript,
  register
} from "../API/apiRequest";
import axios from "axios";
import $ from "jquery";
import { Base64 } from "js-base64";
import { Context } from "../../context/Context";

function LoginNew() {
  const upperBgImage = require("../../Assets/wap/zainIraqS4W/output-onlinepngtools.png");
  const lowerBgImage = require("../../Assets/wap/zainIraqS4W/bottomDarkPurple.png");

  const { handleShowModal } = useContext(Context);

  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");
  const [isDisable, setIsDisable] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [authToken, setAuthToken] = useState("");

  useEffect(() => {
    const tokenFromSession = sessionStorage.getItem("authToken");
  
    if (tokenFromSession) {
      setAuthToken(tokenFromSession); // ✅ Ensure authToken triggers script loading on reload
    } else {
      getAuthorizationToken();
    }
  
    return () => {
      setIsLoader(false);
    };
  }, []);

  const getAuthorizationToken = () => {
    setIsLoader(true);
    authorizationToken()
      .then((resp) => {
        console.log("auth token resp::", resp);
        if (resp?.data?.access_token) {
          const token = resp?.data?.token_type + " " + resp?.data?.access_token;
          if (token) sessionStorage.setItem("authToken", token);
          setAuthToken(token);
        } else if (resp?.errors) {
          const modalData = {
            title: "Error",
            body: 'البيانات المقدمة غير صحيحة.',
            messageCode: resp?.messageCode,
            buttons: [
              {
                label: "حسنًا",
                action: "close",
              },
            ],
            handleClick: function (value) {
              if (value === "close") {
                handleShowModal(false);
              }
              console.log("button clicked");
            },
          };
          handleShowModal(true, modalData);
        }
      })
      .catch((err) => {
        console.log("auth token err", err);
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
      });
  };



  useEffect(() => {
    if (authToken) {
      const existingScript = document.querySelector("script[data-dcb-protect]");
      if (existingScript) {
        console.log("DCBProtect script already injected. Skipping.");
        return; // ❌ Don't inject again
      }
  
      setIsLoader(true); 
      $(document).ready(function () {
        var vars = {
          Authorization: authToken,
        };
        var url =
          "https://swip4winapiv1.bngrenew.com:5081/swipe4win/libly/v1/dcb-script";

        console.log("Request URL:", url); // Log the request URL

        $.ajax({
          url: url,
          // data: vars,
          type: "GET",
          dataType: "json",
          beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", `${authToken}`);
          },
          success: function (data) {
            console.log("data::", data);

            let dcbprotect = data["success"]["dcbprotect"];
            let transaction_identify = data["success"]["transaction_identify"];

            localStorage.setItem("transaction_identify", transaction_identify);

            if (dcbprotect) {
              var script = document.createElement("script");
              script.type = "text/javascript";
              script.setAttribute("data-dcb-protect", "true"); // ✅ Identify the injected script
              script.text = dcbprotect;
              document.body.appendChild(script);
  
              var ev = new Event("DCBProtectRun");
              document.dispatchEvent(ev);
            } else {
              console.error("DCBProtect script content is empty");
            }
  
            setIsLoader(false);
          },
          error: function (data) {
            setIsLoader(false);
            console.error("Error fetching protected script:", data);
          },
        });
      });
  
      document.addEventListener("gateway-load", function () {
        document.getElementById("loader")?.classList.add("hidden_loader");
      });
    }
  }, [authToken]);
  

  const handleMsisdn = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value) && value.length <= 9) { // Allow only numeric input and max 9 digits
      setMsisdn(value);
      setIsDisable(value.length !== 9);
    }
  };


  const handleLogin = (uuid) => {
    login(msisdn, uuid)
      .then((resp) => {
        setIsLoader(false);
        if (resp?.success) {
          navigate(`/otp?type=login`);
        } else {
          setIsLoader(false);
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
      });
  };

  const handleLoginButton = () => {
    if (isDisable) {
      const modalData = {
        title: "Error",
        body: ' يرجى إضافة رقم هاتفك',
        buttons: [
          {
            label: "نعم",
            action: "close",
          },
        ],
        handleClick: function (value) {
          if (value === "close") {
            handleShowModal(false);
          }
          console.log("button clicked");
        },
      };
      handleShowModal(true, modalData);
      return;
    }
    setIsLoader(true);
    localStorage.setItem("msisdn", msisdn);


    register(msisdn)
      .then((resp) => {
        checkSubcription(msisdn)
          .then((resp) => {
            localStorage.setItem("userStatus", resp?.subscriptionResponse?.currentStatus?.toLowerCase())
            localStorage.setItem("userStatusExipry", resp?.subscriptionResponse?.cdrEndDate)
            const currentStatus = resp?.subscriptionResponse?.currentStatus?.toLowerCase();
             let subServiceId = resp?.subscriptionResponse?.subServiceId;
             const derivedOperator = getOperatorFromSubServiceId(subServiceId) || normalizeOperator(resp?.subscriptionResponse?.operator);
             if (derivedOperator) {
               localStorage.setItem("operator", derivedOperator)
             }
             localStorage.setItem("unsubUser", resp?.subscriptionResponse?.reason)
            if (currentStatus === "active" || currentStatus === 'demo') {
              sessionStorage.setItem("isAlreadyActive", "isAlreadyActive")
              login(msisdn)
                .then((resp) => {
                  setIsLoader(false);
                  console.log("login resp::", resp);
                  let msgCode = resp?.messageCode
                  const activeOperator = normalizeOperator(resp?.success?.operator || resp?.operator);
                  if (activeOperator) {
                    localStorage.setItem("operator", activeOperator);
                  }
                  if (resp?.success) {
                    setIsLoader(false);
                    navigate(`/otp?type=active`);
                  } else if (resp?.failed) {
                    setIsLoader(false);
                    const modalData = {
                      title: "Error",
                      body: (msgCode == '300' ? 'هذه العملية غير مسموح بها' : msgCode == '05' ? 'لديك رمز تحقق واحد كل 10 ثوانٍ' : 'حدث خطأ ما.'),
                      messageCode: resp?.messageCode,
                      buttons: [
                        {
                          label: "حسنًا",
                          action: "okay",
                        },
                      ],
                      handleClick: function (value) {
                        if (value === "okay") {
                          handleShowModal(false);
                        }
                        console.log("button clicked");
                      },
                    };
                    handleShowModal(true, modalData);
                  } else {
                    setIsLoader(false);
                    navigate("/sub-status?type=technical_error");
                  }
                })
                .catch((err) => {
                  setIsLoader(false);
                  navigate("/sub-status?type=technical_error");
                  console.log("error in login", err);
                });
              // navigate("/getOtp")
            }
            else if (currentStatus === "new") {
              login(msisdn)
                .then((resp) => {
                  setIsLoader(false);
                  console.log("login resp::", resp);
                  let msgCode = resp?.messageCode
                  const loginOperator = normalizeOperator(resp?.success?.operator || resp?.operator);
                  if (loginOperator) {
                    localStorage.setItem("operator", loginOperator);
                  }
                  if (resp?.success) {
                    console.log("::::::pack lsit:::::::::;", JSON.stringify(resp?.success?.list))
                    localStorage.setItem("packList", JSON.stringify(resp?.success?.list));
                    navigate("/subscription")
                  } else if (resp?.failed) {
                    setIsLoader(false);
                    const modalData = {
                      title: "Error",
                      body: (msgCode == '300' ? 'هذه العملية غير مسموح بها' : msgCode == '05' ? 'لديك رمز تحقق واحد كل 10 ثوانٍ' : 'حدث خطأ ما.'),
                      messageCode: resp?.messageCode,
                      buttons: [
                        {
                          label: "حسنًا",
                          action: "okay",
                        },
                      ],
                      handleClick: function (value) {
                        if (value === "okay") {
                          handleShowModal(false);
                        }
                        console.log("button clicked");
                      },
                    };
                    handleShowModal(true, modalData);
                  } else {
                    setIsLoader(false);
                    navigate("/sub-status?type=technical_error");
                  }
                })
                .catch((err) => {
                  setIsLoader(false);
                  navigate("/sub-status?type=technical_error");
                  console.log("error in login", err);
                });
              // subscriptionActivation(msisdn)
              //   .then((resp) => {
              //     console.log("subs api resp::", resp);
              //     setIsLoader(false);
              //     if (resp?.messageCode == '00') {
              //       setIsLoader(false);
              //       navigate(`/otp?type=subscribe`);
              //     } 
              //     else if (resp?.messageCode == '01') {
              //       setIsLoader(false);
              //       const modalData = {
              //         title: "Error",
              //         body: 'الاشتراك نشط بالفعل.',
              //         messageCode: resp.messageCode,
              //         buttons: [
              //           {
              //             label: "حسنًا",
              //             action: "okay",
              //           },
              //         ],
              //         handleClick: function (value) {
              //           if (value === "okay") {
              //             navigate('/')
              //             handleShowModal(false);
              //           }
              //           console.log("button clicked");
              //         },
              //       };
              //       handleShowModal(true, modalData);
              //     }
              //     else {
              //       setIsLoader(false);
              //       navigate("/sub-status?type=technical_error");
              //     }
              //   })
              //   .catch((err) => {
              //     console.log("error in usb api::", err);
              //     setIsLoader(false);
              //     navigate("/sub-status?type=technical_error");
              //   });
            }
            else if(currentStatus === "unsub" || currentStatus === "unSubscribed" || currentStatus === "unsubscribed"){
              const operator = derivedOperator;
              console.log("::::::::subServiceId:::::::::::", subServiceId, "operator:", operator)
              if (operator === "madar") {
                if (subServiceId == "3 Day Madar") {
                  localStorage.setItem("uuid", "deb47400-0d85-11f1-a8ee-5d429e6c439d")
                  handleLogin("deb47400-0d85-11f1-a8ee-5d429e6c439d")
                }
                else if (subServiceId == "Monthly Madar") {
                  localStorage.setItem("uuid", "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef")
                  handleLogin("3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef")
                }
                else if (subServiceId == "Weekly Madar") {
                  localStorage.setItem("uuid", "076f39e0-0d86-11f1-9bab-5170599866a9")
                  handleLogin("076f39e0-0d86-11f1-9bab-5170599866a9")
                }
              } else {
                if (subServiceId == "daily libyana") {
                  localStorage.setItem("uuid", "db2890c0-67ad-11f0-8756-85ba381b1758")
                  handleLogin("db2890c0-67ad-11f0-8756-85ba381b1758")
                }
                else if (subServiceId == "Monthly libyana") {
                  localStorage.setItem("uuid", "1c2d1180-67ae-11f0-8056-cd05cf2b50ec")
                  handleLogin("1c2d1180-67ae-11f0-8056-cd05cf2b50ec")
                }
                else if (subServiceId == "weekly libyana") {
                  localStorage.setItem("uuid", "e7ed7e20-67ad-11f0-a69c-2369a5da7f55")
                  handleLogin("e7ed7e20-67ad-11f0-a69c-2369a5da7f55")
                }
              }
            }
            else if (currentStatus === 'parking' || currentStatus === 'grace' || currentStatus === 'pending') {
              setIsLoader(false);
              navigate("/sub-status?type=subs_fail");
            }
            else {
              navigate("/sub-status?type=technical_error");
              setIsLoader(false);
            }
          })
          .catch((err) => {
            setIsLoader(false);
            console.log("error in checksub api::", err);
            navigate("/sub-status?type=technical_error");
          });
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
        console.log("register api err::", err);
      })


  };

  const openTerms = () => {
    navigate("/terms-conditions")
  }

  return (
    <>
      {isLoader && <Loader />}
      <div className="bg-loginbackground overflow-y-auto">
        <div className="h-[10vh] rounded-b-3xl bg-white flex justify-center items-center">
          <img
            className="w-28 h-10 cptpl_logo"
            src={require("../../Assets/wap/zainIraqS4W/app_text.png")}
            alt="App Text"
          />
        </div>
        <div className="h-[90vh] bg-buttonYellow relative">
          <img
            src={upperBgImage}
            className="w-full h-[50vh]"
            alt="Upper Background"
          />

          <div className="relative">
            <img
              src={lowerBgImage}
              className="w-full -mt-8 h-[75vh] absolute"
              alt="Lower Background"
            />
            <div className="absolute top-6 left-0 w-full h-full flex flex-col items-center">
              <div className="text-buttonYellow mb-6 text-xl font-semibold">
                تأكيد رقم الهاتف
              </div>
              <div className="flex h-10">
                <div className="text-white bg-lightPurple px-4 py-2 flex justify-center items-center rounded-l-full">
                  {countryCode}
                </div>
                <input
                  type="text"
                  name="msisdn"
                  value={msisdn}
                  onChange={handleMsisdn}
                  className="rounded-r-full pl-2"
                  placeholder="9X XXX XX XX"
                />
              </div>
              <button
                onClick={handleLoginButton}
                disabled={isDisable}
                id="cta_btn"
                className={`cptpl_subscribe h-10 mt-8 rounded-full font-semibold text-lg px-4 py-2 w-80 ${isDisable ? 'opacity-50 cursor-not-allowed bg-buttonYellow' : 'bg-buttonYellow text-darkPurple'}`}
              >تابع الاشتراك</button>
              <p className="cptpl_terms mt-2 font-semibold cursor-pointer underline underline-offset-1 text-buttonYellow" onClick={openTerms}>الشروط والاحكام</p>
              <div className="cptpl_service text-buttonYellow w-[90%] mx-auto pt-6" dir="rtl">
                <p>ما هي خدمة تحدي المعرفة؟ </p>
                <p>هي خدمة تهدف إلى تعزيز وتنمية معلوماتك العامة، مع إتاحة فرصة فريدة لاختبار هذه المعرفة من خلال المشاركة في تحديات معرفية يومية والإجابة على مجموعة من الأسئلة المميزة.</p>
                <div className=" text-right flex flex-col mt-3">
                  <div className="cptpl_price">للاشتراك الشهري 7.5 دينار</div>
                  <div className="cptpl_price">للاشتراك الأسبوعي 3 دينار</div>
                  <div className="cptpl_price">للاشتراك اليومي 0.3 درهم</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default LoginNew;
